import { CheckNotes, InspectionCase } from '../../inspection-cases';

export class WaterFlowTestDto extends InspectionCase {
  waterFlowReservoir?: InspectionCase;
  waterFlowSuctionSide?: InspectionCase;
  waterFlowInstaller?: InspectionCase;
}

export class WaterFlowTest extends WaterFlowTestDto {
  constructor(
    data: WaterFlowTestDto = { title: 'בדיקת הפעלה (בדיקה עם הזרמת מים)' }
  ) {
    super(data);
    this.waterFlowReservoir = new InspectionCase({
      ...data.waterFlowReservoir,
      title: `הזרמת מים דרך מד הספיקה של חדר המשאבות אל המאגר /ניקוז`
    });
    this.waterFlowSuctionSide = new InspectionCase({
      ...data.waterFlowSuctionSide,
      title: `הזרמת מים דרך מד הספיקה  של חדר המשאבות אל צד היניקה של המשאבה`
    });
    this.waterFlowInstaller = new InspectionCase({
      ...data.waterFlowInstaller,
      title: `הזרמת  מים דרך מד ספיקה שהובא על ידי המתקין– ציין סוג מד ספיקה`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.waterFlowReservoir.isApplicable ||
        this.waterFlowReservoir.isPassed) &&
        (!this.waterFlowSuctionSide.isApplicable ||
          this.waterFlowSuctionSide.isPassed) &&
        (!this.waterFlowInstaller.isApplicable ||
          this.waterFlowInstaller.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.waterFlowReservoir.getNotes(),
      ...this.waterFlowSuctionSide.getNotes(),
      ...this.waterFlowInstaller.getNotes()
    ];
  }
}
